module.exports = __webpack_public_path__ + "img/黑蒙版右.62ff4d5a.png";